import { render, staticRenderFns } from "./gylc.vue?vue&type=template&id=9168c184&scoped=true"
import script from "./gylc.vue?vue&type=script&lang=js"
export * from "./gylc.vue?vue&type=script&lang=js"
import style0 from "./gylc.vue?vue&type=style&index=0&id=9168c184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9168c184",
  null
  
)

export default component.exports